module.exports = __webpack_public_path__ + "static/media/how-does-it-work-es.4fedbef4.svg";